/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React, {Fragment, useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {useLocation} from 'react-router-dom'
// Project Components
// import { ListMenuContent } from '@salesforce/retail-react-app/app/components/list-menu/list-menu-content'
import {ListMenuContent} from './list-menu-content'
// import {ListMenuTrigger} from '@salesforce/retail-react-app/app/components/list-menu/list-menu-trigger'
import {ListMenuTrigger} from './list-menu-trigger'

// Components
import {
    Box,
    Popover,
    PopoverContent,
    PopoverBody,

    // Hooks
    useDisclosure,
    useTheme,
    Divider
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {ListMenuContentInner} from './list-menu-content-inner'
const ListMenuPopover = ({
    contentComponent,
    item,
    items,
    name,
    itemsKey,
    maxColumns,
    setMenuToggle
}) => {
    const initialFocusRef = useRef(null)

    const {isOpen, onClose, onOpen} = useDisclosure()
    const ContentComponent = contentComponent || ListMenuContent
    const theme = useTheme()
    const {baseStyle} = theme.components.ListMenu

    const [featureImage, setfeatureImage] = useState('')
    const [featureImageMobileLevelTwo, setFeatureImageMobileLevelTwo] = useState('')
    const [featureImageMobileLevelThree, setFeatureImageMobileLevelThree] = useState('')
    const [featureImageMobileLevelFour, setFeatureImageMobileLevelFour] = useState('')
    const [selectedLevelOneMenu, setSelectedLevelOneMenu] = useState({})
    const [selectedLevelTwoMenu, setSelectedLevelTwoMenu] = useState({})
    const [linksForLevelTwoMenu, setLinksForLevelTwoMenu] = useState([])
    const [linksForLevelThreeMenu, setLinksForLevelThreeMenu] = useState([])
    const [isLevelTwoMenuOpen, setIsLevelTwoMenuOpen] = useState(false)
    const [isLevelThreeMenuOpen, setIsLevelThreeMenuOpen] = useState(false)
    const [linksForContentComp, setLinksForContentComp] = useState({})
    const location = useLocation()

    const handleOnClose = () => {
        onClose()
        setLinksForLevelTwoMenu([])
        setLinksForLevelThreeMenu([])
        setIsLevelTwoMenuOpen(false)
        setIsLevelThreeMenuOpen(false)
        setSelectedLevelOneMenu({})
        setSelectedLevelTwoMenu({})
    }

    useEffect(() => {
        if (item) setfeatureImage(item?.c_headerMenuBanner)
    }, [item])

    useEffect(() => {
        handleOnClose()
    }, [location])

    return (
        <Box onMouseLeave={handleOnClose}>
            <Popover
                isLazy
                placement={'bottom-start'}
                initialFocusRef={initialFocusRef}
                onOpen={onOpen}
                onClose={handleOnClose}
                isOpen={isOpen}
                variant="fullWidth"
            >
                <Fragment>
                    <ListMenuTrigger
                        item={item}
                        name={name}
                        isOpen={isOpen}
                        onOpen={onOpen}
                        onClose={handleOnClose}
                    />
                    <PopoverContent data-testid="popover-menu" {...baseStyle.popoverContent}>
                        <PopoverBody {...baseStyle.popoverBody}>
                            <Box {...baseStyle.menuContainer}>
                                <Box width="33.3%">
                                    <ContentComponent
                                        item={item}
                                        itemsKey={itemsKey}
                                        onClose={handleOnClose}
                                        maxColumns={maxColumns}
                                        setMenuToggle={setMenuToggle}
                                        setfeatureImage={setfeatureImage}
                                        isMobileMenu={false}
                                        selectedLevelOneMenu={selectedLevelOneMenu}
                                        selectedLevelTwoMenu={selectedLevelTwoMenu}
                                        setSelectedLevelOneMenu={setSelectedLevelOneMenu}
                                        setSelectedLevelTwoMenu={setSelectedLevelTwoMenu}
                                        setLinksForLevelThreeMenu={setLinksForLevelThreeMenu}
                                        setLinksForLevelTwoMenu={setLinksForLevelTwoMenu}
                                        setIsLevelTwoMenuOpen={setIsLevelTwoMenuOpen}
                                        setIsLevelThreeMenuOpen={setIsLevelThreeMenuOpen}
                                        isLevelTwoMenuOpen={isLevelTwoMenuOpen}
                                        isLevelThreeMenuOpen={isLevelThreeMenuOpen}
                                        setLinksForContentComp={setLinksForContentComp}
                                        setFeatureImageMobileLevelTwo={
                                            setFeatureImageMobileLevelTwo
                                        }
                                        setFeatureImageMobileLevelThree={
                                            setFeatureImageMobileLevelThree
                                        }
                                        setFeatureImageMobileLevelFour={
                                            setFeatureImageMobileLevelFour
                                        }
                                    />
                                </Box>

                                <Box width="33.3%">
                                    {linksForLevelTwoMenu?.length > 0 && (
                                        <ListMenuContentInner
                                            items={linksForLevelTwoMenu}
                                            onClose={handleOnClose}
                                            initialFocusRef={initialFocusRef}
                                            setMenuToggle={setMenuToggle}
                                            isMobileMenu={false}
                                            setSelectedLevelOneMenu={setSelectedLevelOneMenu}
                                            setSelectedLevelTwoMenu={setSelectedLevelTwoMenu}
                                            setfeatureImage={setfeatureImage}
                                            selectedLevelOneMenu={selectedLevelOneMenu}
                                            selectedLevelTwoMenu={selectedLevelTwoMenu}
                                            setLinksForLevelThreeMenu={setLinksForLevelThreeMenu}
                                            setLinksForLevelTwoMenu={setLinksForLevelTwoMenu}
                                            isLevelTwo={true}
                                            setIsLevelTwoMenuOpen={setIsLevelTwoMenuOpen}
                                            setIsLevelThreeMenuOpen={setIsLevelThreeMenuOpen}
                                            isLevelTwoMenuOpen={isLevelTwoMenuOpen}
                                            isLevelThreeMenuOpen={isLevelThreeMenuOpen}
                                            setFeatureImageMobileLevelTwo={
                                                setFeatureImageMobileLevelTwo
                                            }
                                            setFeatureImageMobileLevelThree={
                                                setFeatureImageMobileLevelThree
                                            }
                                            setFeatureImageMobileLevelFour={
                                                setFeatureImageMobileLevelFour
                                            }
                                        />
                                    )}
                                </Box>

                                <Box width="33.3%">
                                    {linksForLevelThreeMenu?.length > 0 && (
                                        <ListMenuContentInner
                                            items={linksForLevelThreeMenu}
                                            onClose={handleOnClose}
                                            initialFocusRef={initialFocusRef}
                                            setMenuToggle={setMenuToggle}
                                            isMobileMenu={false}
                                            setSelectedLevelOneMenu={setSelectedLevelOneMenu}
                                            setSelectedLevelTwoMenu={setSelectedLevelTwoMenu}
                                            setfeatureImage={setfeatureImage}
                                            selectedLevelOneMenu={selectedLevelOneMenu}
                                            selectedLevelTwoMenu={selectedLevelTwoMenu}
                                            isLevelTwo={false}
                                            setLinksForLevelThreeMenu={setLinksForLevelThreeMenu}
                                            setLinksForLevelTwoMenu={setLinksForLevelTwoMenu}
                                            setIsLevelTwoMenuOpen={setIsLevelTwoMenuOpen}
                                            setIsLevelThreeMenuOpen={setIsLevelThreeMenuOpen}
                                            isLevelTwoMenuOpen={isLevelTwoMenuOpen}
                                            isLevelThreeMenuOpen={isLevelThreeMenuOpen}
                                            setFeatureImageMobileLevelTwo={
                                                setFeatureImageMobileLevelTwo
                                            }
                                            setFeatureImageMobileLevelThree={
                                                setFeatureImageMobileLevelThree
                                            }
                                            setFeatureImageMobileLevelFour={
                                                setFeatureImageMobileLevelFour
                                            }
                                        />
                                    )}
                                </Box>
                            </Box>
                            <Box {...baseStyle.imageContainer}>
                                {/* level 2 feature image */}
                                {Object.keys(item)?.length > 0 &&
                                    !linksForLevelTwoMenu?.length > 0 && (
                                        <>
                                            {
                                                <Box
                                                    width={['100%', '100%', '100%', '100%']}
                                                    dangerouslySetInnerHTML={{__html: featureImage}}
                                                ></Box>
                                            }
                                        </>
                                    )}

                                {/* level 3feature image  */}
                                {linksForLevelTwoMenu?.length > 0 &&
                                    !linksForLevelThreeMenu?.length > 0 && (
                                        <>
                                            {linksForLevelTwoMenu?.length > 0 && (
                                                <Box
                                                    width={['100%', '100%', '100%', '100%']}
                                                    dangerouslySetInnerHTML={{
                                                        __html: featureImageMobileLevelThree
                                                    }}
                                                ></Box>
                                            )}
                                        </>
                                    )}

                                {/* level 4 feature image */}
                                {linksForLevelThreeMenu?.length > 0 && (
                                    <>
                                        {linksForLevelThreeMenu?.length > 0 && (
                                            <Box
                                                width={['100%', '100%', '100%', '100%']}
                                                dangerouslySetInnerHTML={{
                                                    __html: featureImageMobileLevelFour
                                                }}
                                            ></Box>
                                        )}
                                    </>
                                )}
                            </Box>
                        </PopoverBody>
                    </PopoverContent>
                    {/* )} */}
                </Fragment>
            </Popover>
        </Box>
    )
}

ListMenuPopover.propTypes = {
    contentComponent: PropTypes.elementType,
    item: PropTypes.object,
    name: PropTypes.string,
    maxColumns: PropTypes.number,
    itemsKey: PropTypes.string,
    items: PropTypes.array,
    setMenuToggle: PropTypes.func
}

export {ListMenuPopover}
